import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col, Container, Button, Alert } from "react-bootstrap";
import axios from 'axios';
import "./about.css";
//import image1 from "./image1.png";

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || ''}/api`;

const About = () => {
  useEffect(() => {
    document.title = "Enigma Labs | About";
    document.querySelector('meta[name="description"]')?.setAttribute(
      "content",
      "Learn about Enigma Labs — a Miami-based creative studio serving all of South Florida with web development, marketing, content creation, photography, videography, music production and audio engineering."
    );
  }, []);

  const rowStyle = {
    margin: '5%'
  };

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [socialUrl, setSocialUrl] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [beats, setBeats] = useState(false);
  const [visuals, setVisuals] = useState(false);
  const [web, setWeb] = useState(false);
  const [ads, setAds] = useState(false);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("");
  // Honeypot — real users never see or fill this; bots that auto-fill every
  // input on the page do. Combined with formLoadedAt (a timing trap: humans
  // take at least a few seconds to fill the form) on the backend.
  const [honeypot, setHoneypot] = useState("");
  const [formLoadedAt] = useState(() => Date.now());

  const newsletterCardStyle = {
    backgroundColor: "#111",
    border: "1px solid #68FF00",
    borderRadius: "20px",
    boxShadow: "0 0 30px rgba(104, 255, 0, 0.15)",
    padding: "2.75rem 2rem"
  };

  const newsletterInputStyle = {
    display: "block",
    width: "100%",
    padding: "0.85rem 1.15rem",
    borderRadius: "2rem",
    border: "1px solid #333",
    backgroundColor: "#1a1a1a",
    color: "#fff",
    fontSize: "1rem",
    outline: "none"
  };

  const newsletterButtonStyle = {
    marginTop: "1.75rem",
    padding: "0.85rem 2.75rem",
    backgroundColor: "#68FF00",
    color: "#000",
    border: "none",
    borderRadius: "2rem",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "0.05em",
    fontSize: "1rem",
    cursor: "pointer"
  };

  const newsletterChipStyle = (active: boolean) => ({
    display: "inline-block",
    padding: "0.55rem 1.1rem",
    margin: "0.3rem",
    borderRadius: "2rem",
    border: "1px solid #68FF00",
    backgroundColor: active ? "#68FF00" : "transparent",
    color: active ? "#000" : "#68FF00",
    fontWeight: 600,
    fontSize: "0.85rem",
    cursor: "pointer",
    userSelect: "none" as const,
    transition: "all 0.15s ease"
  });

  const interestOptions: { key: string; label: string; active: boolean; toggle: () => void }[] = [
    { key: "web", label: "Web Development", active: web, toggle: () => setWeb(!web) },
    { key: "visuals", label: "Branding", active: visuals, toggle: () => setVisuals(!visuals) },
    { key: "ads", label: "Ads", active: ads, toggle: () => setAds(!ads) },
    { key: "beats", label: "Music", active: beats, toggle: () => setBeats(!beats) },
  ];

  async function handleSubmit() {
    if (!email) {
      setAlert('Please set an e-mail address~');
      return;
    }

    // Picking any interest is what opts them into the newsletter — no
    // separate opt-in checkbox.
    const wantsNewsletter = beats || visuals || web || ads;

    const dataToSend = {
      email,
      name,
      phone,
      socialUrl,
      message: contactMessage,
      beats,
      visuals,
      web,
      ads,
      website: honeypot,
      formLoadedAt
    };

    const headers = { 'Content-Type': 'application/json' };

    // Sent separately so a hiccup in one doesn't block the other — the admin
    // notification email is the point of this form. The newsletter signup
    // only fires if the user picked at least one interest.
    const requests = [axios.post(`${API_BASE_URL}/contact/submit`, dataToSend, { headers })];
    if (wantsNewsletter) {
      requests.push(axios.post(`${API_BASE_URL}/newsletter/subscribe`, dataToSend, { headers }));
    }
    const results = await Promise.allSettled(requests);

    if (results.every((result) => result.status === 'rejected')) {
      console.error('Contact form submission failed', results.map((result) => result.status === 'rejected' && result.reason));
      setAlert("There was an error.");
      setMessage('');
      return;
    }

    setMessage(
      wantsNewsletter
        ? "Thanks! Your message has been sent and you're on our newsletter list."
        : "Thanks! Your message has been sent."
    );
    setAlert('');
  }

      return (
        <Container className="aboutContainer">
          
          <Row style={rowStyle}>
            <Col sm={2}></Col>
            <Col sm={8}>
              <h1 className="centerText aboutTitle">About</h1>
            </Col>
            <Col sm={2}></Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={12}>
              <h5>Based out of Miami, FL, Enigma Labs is your all in one digital growth agency. We help businesses generate more customers through high-converting websites, branding, marketing & ads. We build modern, custom websites that fit the needs of our clients, also providing Audio Visual Services.</h5>
              <h5>With over half a decade of experience in Software Development and over a decade of experience in Music Production, Video Production, Marketing & Audio Engineering, we are equipped with the tools needed for any project. The full stop shop to push your business to the next level.</h5>
              <h5>Our services include Web Design and Development, Photography, Videography, Graphic Design, Content Creation, Social Media Management & Ads, Music Production & Audio Engineering.</h5>
              <h5 style={{marginTop: "5%"}}>Why should you hire a Digital Growth Agency?</h5>
              <ul>
                <li>Prioritize your needs</li>
                <li>Save money on licensing software</li>
                <li>Save time and have your projects completed by experts</li>
              </ul>

              <hr style={{backgroundColor:"white", marginTop: "3%"}}/>
              <h2>Team</h2>
              <h5>CEO, Gen Barrios</h5>
              <p> Software Engineer, Music Producer & Audio Engineer, Content Creator </p>
              <a  className="socialLinks" href="mailto:info@enigma-labs.com">Email</a>
              <a  className="socialLinks" href="https://linkedin.com/in/genesis-barrios" target="_blank">LinkedIn</a>
              <a  className="socialLinks" href="https://genesisbarrios.xyz" target="_blank">Programming Portfolio</a>
              <a  className="socialLinks" href="https://github.com/genesisbarrios" target="_blank">Github</a>
              <a  className="socialLinks" href="https://instagram.com/gen.wav" target="_blank">Instagram</a>

            </Col>
          </Row>

          <Row style={{ ...rowStyle, marginTop: "6%", marginBottom: "6%" }}>
            <Col xs={12} className="mt-4 mt-md-0 d-flex justify-content-center justify-content-md-start align-items-center">
              <div className="contact-card" style={newsletterCardStyle}>
                <form style={{ textAlign: "center", width: "100%" }}>
                  <h3 style={{ color: "#68FF00", marginBottom: "1.5rem" }}>Contact Us</h3>
                  {/* Honeypot — hidden from real users, tempting for bots that auto-fill every field */}
                  <input
                    type="text"
                    name="website"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
                  ></input>
                  <Row className="g-3 mb-3">
                    <Col xs={12} md={6}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your name"
                        style={newsletterInputStyle}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      ></input>
                    </Col>
                    <Col xs={12} md={6}>
                      <input
                        type="email"
                        name="e-mail"
                        placeholder="your@email.com"
                        style={newsletterInputStyle}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      ></input>
                    </Col>
                  </Row>
                  <Row className="g-3 mb-3">
                    <Col xs={12} md={6}>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone number"
                        style={newsletterInputStyle}
                        onChange={(e) => {
                          setPhone(e.target.value);
                        }}
                      ></input>
                    </Col>
                    <Col xs={12} md={6}>
                      <input
                        type="text"
                        name="social-url"
                        placeholder="Instagram handle (optional)"
                        style={newsletterInputStyle}
                        onChange={(e) => {
                          setSocialUrl(e.target.value);
                        }}
                      ></input>
                    </Col>
                  </Row>
                  <Row className="g-3 mb-3">
                    <Col xs={12}>
                      <textarea
                        name="message"
                        placeholder="Tell us about your project (optional)"
                        rows={4}
                        style={{ ...newsletterInputStyle, resize: "vertical" as const }}
                        onChange={(e) => {
                          setContactMessage(e.target.value);
                        }}
                      ></textarea>
                    </Col>
                  </Row>
                  <label style={{ display: "block", color: "#d4d4d4", marginBottom: "0.5rem" }}>
                    Interested in our newsletter? Select what applies:
                  </label>
                  <div style={{ textAlign: "center" }}>
                    {interestOptions.map((option) => (
                      <span
                        key={option.key}
                        role="checkbox"
                        aria-checked={option.active}
                        tabIndex={0}
                        style={newsletterChipStyle(option.active)}
                        onClick={option.toggle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            option.toggle();
                          }
                        }}
                      >
                        {option.label}
                      </span>
                    ))}
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    style={newsletterButtonStyle}
                    type="submit"
                  >
                    Submit
                  </button>
                  {message && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#111", borderColor: "#68FF00", color: "#68FF00" }}>{message.toString()}</Alert>}
                  {alert && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#2a0000", borderColor: "#ff4d4d", color: "#ff9d9d" }}>{alert.toString()}</Alert>}
                </form>
              </div>
            </Col>
          </Row>
        </Container>

      );
  
};



export default About;
//<img src={image1} style={{width: '100%', height: '80%'}}/>